import React, { useEffect, useState } from "react";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import { usePlanetasRandom } from "./hooks/usePlanetasRandom";
import { useGenerateFigures } from "./hooks/useGenerateFigures";
import { usePositionsRandom } from "./hooks/usePositionsRandom";
import imageBackground from "./assets/background.gif";
import Style from "./assets/Style.module.scss";
import { useMovesRandom } from "./hooks/useMovesRandom";
import { ResultModal } from "./ResultModal";
import { Instruction } from "./Instructions";
import { usePlayMusic } from "./hooks/usePlayMusic";

const stepGamesKeys = ["instruction", "startGame", "finishGame"] as const;
export type StepGamesType = typeof stepGamesKeys[number];

const JueguitoGuls: React.FC<RouteProps> = () => {
  const [stepGame, setStepGame] = useState<StepGamesType>("instruction");
  const [restartGame, setRestartGame] = useState(false);
  const { Figures } = useGenerateFigures(restartGame);
  const cantFigures = Figures?.length;
  const planetas = usePlanetasRandom(cantFigures);
  const posiciones = usePositionsRandom(cantFigures);
  const moves = useMovesRandom(cantFigures);
  const [points, setPoints] = useState(0);
  const [positionFigure, setPositionFigure] = useState(cantFigures - 1);
  const { generateMusic, music } = usePlayMusic();

  useEffect(() => {
    if (!music?.play()) generateMusic();
  }, [music, stepGame]);

  useEffect(() => {
    ///generar un nuevo juego
    if (stepGame == "startGame") {
      setPositionFigure(cantFigures - 1);
      setRestartGame(false);
    }
  }, [stepGame]);

  useEffect(() => {
    //verificar si termino el juego
    if (positionFigure == -1) {
      setStepGame("finishGame");
    }
  }, [positionFigure]);

  return (
    <div>
      <img className={Style.image} src={imageBackground} alt='animateImage' />
      {stepGame === "instruction" && <Instruction setStartGame={setStepGame} />}
      {stepGame === "finishGame" && (
        <ResultModal
          setRestartGame={setRestartGame}
          setPoints={setPoints}
          setStartGame={setStepGame}
          cantFigures={cantFigures}
          points={points}
        />
      )}
      {stepGame === "startGame" &&
        Figures.map(
          (Figure, index) =>
            positionFigure == index && (
              <Figure
                lifeTime={1}
                onClick={() => {
                  setPoints(points + 1);
                  setPositionFigure(positionFigure - 1);
                }}
                onNoPress={() => {
                  setPositionFigure(positionFigure - 1);
                }}
                position={{
                  position: "absolute",
                  top: posiciones[index].x,
                  left: posiciones[index].y
                }}
                key={index}
                planeta={planetas[index]}
                move={moves[index]}
              />
            )
        )}
    </div>
  );
};

export default new Content({
  Component: JueguitoGuls,
  title: "Juego Guls",
  route: "juegitoGuls"
});
